// @flow

import React from 'react';
import classNames from 'classnames';
import './FormTabs.css';
import _ from 'lodash/fp';

export type Props = {
  title: string,
  tabs: any[],
  includeArchived: boolean,
  onArchivedChanged: Function,
  onSelect: Function,
  onAdd: Function,
};

const FormTabs = ({title, tabs, onSelect, onAdd, onArchivedChanged, includeArchived}: Props) => (
  <div className="FormTabs">
    <div className="title">
      <span>{title}</span>
    </div>
    <div>
      <input
        className="archive-toggle"
        value={includeArchived}
        type="checkbox"
        onChange={e => onArchivedChanged(!!e.target.checked)} />
      Visa arkiverade
    </div>
    {_.map(t => (
      <div
        className={classNames({
          'form-tab': true,
          active: t.active,
        })}
        onClick={() => onSelect(t)}
        key={t.id}>
        {t.label}
      </div>
    ), tabs)}
    <hr />
    <div className="tools">
      <button
        onClick={() => onAdd()}
        type="button"
        className="button small expanded">
        Lägg till
      </button>
    </div>
  </div>
);

export default FormTabs;



// WEBPACK FOOTER //
// ./src/components/FormTabs/FormTabs.js